import { z } from 'zod'
import { Currency } from '~library/enums'
import { enumWithEmpty } from '~library/models'
import { travelAmountStatisticsMonthDetailSchema } from './travel-amount-statistics-month-detail'

export const historyTravelAmountSchema = z.object({
  /** 年份 */
  year: z.string(),
  /** 幣別 */
  capCurrency: enumWithEmpty(Currency),
  /** 金額 */
  amount: z.number(),
  /** 月份明細資料 */
  monthDetail: z.array(travelAmountStatisticsMonthDetailSchema)
})

export interface HistoryTravelAmount
  extends z.infer<typeof historyTravelAmountSchema> {}

export class HistoryTravelAmount {
  constructor() {
    return {
      year: '',
      capCurrency: '',
      amount: 0,
      monthDetail: []
    }
  }
}
